<template>
  <div style="height:100%">
    <SplitContainer2 style="height:100%" :split_setting="0.35">
      <template #table1>
        <div style="height:100%">
          <TableMain name="one table" ref="roleManageRef1" :fields="fields" :title="table_title.title1"
            :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
            :show_date_picker="false" :show_toolbar="true" :show_filter="true" :show_check="true"
            :date_picker_label="date_picker_label" :query_button_label="query_lable" @on_query="on_query"
            @state_change="state_change" :show_toolbar_button="[1, 1, 0, 0, 1]" @current_changed="current_changed"
            :specialExport="true" @specialExport="exportRolePrivileges" @on_cell_button_click="on_cell_button_click"
            tableref="f04aeeedb6814215a13adf5281029b10">

            <template #specialExport>
              <el-dropdown-item command="specialExport" divided>{{ $t('common.rolePrivilegeExport')
              }}</el-dropdown-item>
            </template>
            <template #toolbar="">
              <el-button type="info" plain @click="createForm('new')" style="width: 55px;"
                class="ml-2 iconfont icon-add-new" size="mini">
              </el-button>
              <el-badge :value="copyPrivilegesNum" :hidden="copyPrivilegesNum == 0"
                style="vertical-align: top !important">
                <el-tooltip content="拷贝所选角色拥有的权限" placement="top" effect="light">
                  <el-button type="info" plain style="width: 55px" class="ml-2 iconfont icon-copy"
                    @click="copyPrivileges" size="mini">
                  </el-button>
                </el-tooltip>
              </el-badge>
              <el-tooltip content="权限粘贴" placement="top" effect="light">
                <el-button type="info" plain style="width: 55px" class="ml-4 iconfont icon-paste"
                  @click="syncPrivileges" size="mini">
                </el-button>
              </el-tooltip>
              <el-tooltip content="权限追加" placement="top" effect="light">
                <el-button type="info" plain style="width: 55px" class="ml-2 iconfont icon-append"
                  @click="pastePrivileges" size="mini">
                </el-button>
              </el-tooltip>
            </template>

          </TableMain>
        </div>
      </template>
      <template #table2>
        <div style="height:100%">
          <el-col :span="24" v-for="(rp_item, index) in rolePropertyList" :key="index">
            <el-form-item label="控制点">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                @change="handleCheckAllChange">全选</el-checkbox>
              <el-checkbox-group v-model="checkedProperties" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in property_options" :label="item.text" :key="item.value">{{ item.text
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </div>
      </template>

    </SplitContainer2>
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData" :size="'md'">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-form-item label="角色编码" prop="code">
            <el-input v-model="dataForm.code"></el-input>
          </el-form-item>
          <el-form-item label="角色名称" prop="name">
            <el-input v-model="dataForm.name"></el-input>
          </el-form-item>
          <el-form-item label="角色说明" prop="description">
            <el-input type="textarea" v-model="dataForm.description"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import BaseModal from "../components/modals/baseModal"
import * as api from "../../shared/api"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import SplitContainer2 from "../components/container/SplitContainer2"
import * as RolePropertyManageController from "../../controllers/system/RolePropertyManageController"
import * as PropertyManageTestController from "../../controllers/system/PropertyManageTestController"

export default {
  name: "RolePropertyTest",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    SplitContainer2,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_role",
        title3: "table_role_user",
      },
      modal_title: "新建角色",
      fields: RoleManageController.fields,
      fields2: RoleManageController.fields2,
      role_users_fileds: RoleManageController.role_users_fileds,
      dataForm: _.cloneDeep(RoleManageController.dataForm),
      rules: RoleManageController.rules,
      methods: RoleManageController.methods,
      roleName: "",
      items: [],
      selectedItem: null,
      roleHasData: [],
      roleNewData: [],
      copyPrivilegesNum: 0,
      copyItems: [],
      rolePropertyList: [],

      checkAll: false,
      checkedProperties: [],
      property_options: [
        { value: "search", text: "查询" },
        { value: "add", text: "新增" },
        { value: "update", text: "修改" },
        { value: "delete", text: "删除" },
        { value: "approve", text: "审核" },
        { value: "unapprove", text: "反审" },
        { value: "export_out", text: "导出" },
        { value: "export_in", text: "导入" },
        { value: "print", text: "打印" },
        { value: "creidt_approve", text: "信用审批" },
        { value: "creidt_unapprove", text: "信用反审" },
        { value: "price_approve", text: "价格审批" },
        { value: "price_unapprove", text: "价格反审" },
      ],
      isIndeterminate: false
    }
  },
  created() {
  },
  methods: {
    //同步
    async syncPrivileges() {
      if (this.$refs.roleManageRef1.GetSelectedItems().length == 0) {
        this.msgToasts("请选择要粘贴的角色!", "info")
        return
      }
      if (this.copyItems.length == 0) {
        this.msgToasts("没有需要粘贴的项!", "info")
        return
      }
      this.msgModal("同步权限将清除角色自身含有的所有权限,确定此操作?").then(
        async (value) => {
          if (value) {
            let roleIds = []
            _.each(this.$refs.roleManageRef1.GetSelectedItems(), (t) => {
              roleIds.push(t.id)
            })
            let _result = await RoleManageController.methods.syncRolePrivileges(
              roleIds,
              this.copyItems
            )
            if (_result && _result.length > 0) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
            }
          }
        }
      )
    },
    //追加
    async pastePrivileges() {
      if (this.$refs.roleManageRef1.GetSelectedItems().length == 0) {
        this.msgToasts("请选择要粘贴的角色!", "info")
        return
      }
      if (this.copyItems.length == 0) {
        this.msgToasts("没有需要粘贴的项!", "info")
        return
      }
      let roleIds = []
      _.each(this.$refs.roleManageRef1.GetSelectedItems(), (t) => {
        roleIds.push(t.id)
      })
      let _result = await RoleManageController.methods.pasteRolePrivileges(
        roleIds,
        this.copyItems
      )
      if (_result && _result.length > 0) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      }
    },
    //拷贝
    copyPrivileges() {
      this.copyItems = []
      if (!this.$refs.roleManageRef1.GetCurrentItem()) {
        this.msgToasts("请选择要复制的角色!", "info")
        return
      }
      if (this.$refs.roleOwnPrivilegesRef.GetSelectedItems().length < 1) {
        this.copyPrivilegesNum = 0
        return
      }
      _.each(this.$refs.roleOwnPrivilegesRef.GetSelectedItems(), (t) => {
        this.copyItems.push(t.id)
      })
      this.copyPrivilegesNum = this.copyItems.length
      this.msgToasts("已拷贝角色权限!", "success")
    },
    //编辑
    async on_cell_button_click(data) {
      for (var i in this.dataForm) {
        if (_.isNull(data.item[i])) {
          this.dataForm[i] = ""
        } else {
          this.dataForm[i] = data.item[i]
        }
      }
      this.createForm("edit")
    },
    //保存角色权限
    async saveRoleOwnPrivileges() {
      let _this = this
      if (this.selectedItem == null) {
        this.msgToasts("请选择角色后再进行保存！", "warning")
        return
      }
      this.roleNewData = _.filter(
        _this.$refs.roleOwnPrivilegesRef.my_data,
        (d) => d._selected
      )

      let _b = await this.methods.AddORDeleteRoleOwnPrivileges(
        _this.selectedItem.id,
        _this.roleHasData,
        _this.roleNewData
      )
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
    },
    //获取权限
    async GetPrivilige() {
      let _dt = await this.methods.GetPrivilege()
      this.$refs.roleOwnPrivilegesRef.SetData(_dt)
    },
    //#region 查询
    async on_query(set_data) {
      let _dt = await this.methods.GetRoleList()
      _dt = _.filter(_dt, { is_sys: false })
      set_data(_.orderBy(_dt, ["seq"], ["asc"]))
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "新增角色"
          this.dataForm = _.cloneDeep(RoleManageController.dataForm)
          break
        case "edit":
          title = "编辑角色"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
    },
    ///新增修改
    async saveData(cb) {
      let _this = this
      await this.$refs.dataForm.validate((valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)
          ///保存数据
          _this.addRole(_data, cb)
        } else {
          cb(false)
          return false
        }
      })
    },
    // 新增
    async addRole(_data, cb) {
      let b = await this.methods.AddRole({
        id: _data.id,
        name: _data.name,
        code: _data.code,
        description: _data.description,
        is_valid: _data.is_valid,
      })
      cb(true, b.success)
      //如果未新增则在表格中新增一条数据
      //如过修改 则在表格中修改
      if (_data.id) {
        let index = _.findIndex(this.$refs.roleManageRef1.my_data, {
          id: _data.id,
        })
        if (index > -1) {
          this.$set(
            this.$refs.roleManageRef1.my_data[index],
            "name",
            _data.name
          )
          this.$set(
            this.$refs.roleManageRef1.my_data[index],
            "description",
            _data.description
          )
        }
      } else {
        if (_.findIndex(this.$refs.roleManageRef1.my_data, { id: b.id }) < 0) {
          this.$refs.roleManageRef1.my_data.splice(0, 0, {
            id: b.id,
            name: _data.name,
            code: _data.code,
            description: _data.description,
            is_valid: true,
            is_sys: true,
            _current: false,
            _id: b.id,
            _selected: false,
          })
        }
      }
    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      let _b = await this.methods.UpdateRole(data)
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      } else {
        this.msgToasts("操作失败！", "error")
      }
      cb(data.state) //回调table操作
    },
    //#endregion

    async current_changed(old, current) {

      if (!current) {
        return
      }
      let _result = await PropertyManageTestController.methods.getData()

      this.rolePropertyList = []
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.rolePropertyList = _result[0]
      }
    },
    //获取角色对应的权限
    async getRolePrivileges(id) {
      let _this = this
      let _dt = await this.methods.GetRoleOwnPrivilege(id)
      this.roleHasData = _dt
      _this.$refs.roleOwnPrivilegesRef.setSelect(_dt)
    },


    //导出角色权限列表
    async exportRolePrivileges() {
      let loading = null
      let _this = this
      loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        background: "rgba(0, 0, 0, 0.7)",
      })
      let roleIds = []
      if (this.$refs.roleManageRef1.my_data.length < 1) {
        loading.close()
        this.msgToasts(this.$t("notify.not_data"), "info")

        return
      }
      _.each(this.$refs.roleManageRef1.my_data, (t) => {
        roleIds.push(t.id)
      })
      let selected_items = []
      let dataList =
        await RolePropertyManageController.methods.GetRoleAllPrivilegeList(
          roleIds
        )

      _.each(dataList, (t) => {
        _.each(t.result.data.Result, (y) => {
          selected_items.push(y)
        })
      })


      if (selected_items.length < 1) {
        loading.close()
        _this.msgToasts(this.$t("notify.not_selected_data"), "warning")
        return
      }
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../shared/Export2Excel")
        const tHeader = []
        const filterVal = []
        let my_fields = RoleManageController.role_users_export_fileds
        for (var i in my_fields) {
          //过滤首列
          if (my_fields[i].key != "_selected") {
            tHeader.push(my_fields[i].label)
            filterVal.push(my_fields[i].key)
          }
        }
        const list = selected_items

        const data = list.map((v) => filterVal.map((j) => v[j]))
        var numReg = /^[0-9]*$/
        var numRe = new RegExp(numReg)
        for (var index = 0; index < data.length; index++) {
          for (var j in data[index]) {
            if (data[index][j] == true && !numRe.test(data[index][j])) {
              data[index][j] = "√"
            }
            if (data[index][j] == false && !numRe.test(data[index][j])) {
              data[index][j] = ""
            }
          }
        }

        export_json_to_excel(tHeader, data, this.$t("table.table_role_property"), "", loading)
      })
    },

  },
}
</script>
<style>
.role-table {
  /* width: auto; */
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 1000px;
}
</style>
